import React, { useState, Fragment, useRef } from 'react';
import style from './select.module.scss';
import DownIcon from '../../../../../assets/svg/solo-chat/down.svg';
import ExpandIcon from '../../../../../assets/svg/solo-chat/expand-3.svg';
import { useOnClickOutside } from '../hooks';

export type Option = {
	label: string;
	value: string;
	options?: Option[];
};

type Props = {
	placeholder: string;
	options: Option[];
	value: string;
	onSelect: (value: string) => void;
	customLabel?: string;
	required?: boolean
};

export function Select(props: Props) {
	const ref = useRef(null);
	 const { placeholder, options, value, onSelect, customLabel, required = false} = props;
	const [isOpen, setIsOpen] = useState(false);
	const [submenu, setSubmenu] = useState({
		id: '',
		visibility: false,
	});
	const label =
		customLabel ?? options.find((option) => option.value === value)?.label;
	useOnClickOutside(ref, () => {
		setIsOpen(false);
		setSubmenu({
			id: '',
			visibility: false,
		});
	});

	return (
		<div
			ref={ref}
			role="button"
			className={style.select}
			onClick={() => {
				setIsOpen(!isOpen);
				setSubmenu({
					id: '',
					visibility: false,
				});
			}}
		>
			<p data-required={required} data-has-value={Boolean(label)}>{label ?? placeholder}</p>
			<img
				onClick={() => {
					setSubmenu({ visibility: false, id: '' });
				}}
				className={style.main}
				data-open={isOpen}
				src={DownIcon}
				alt="open"
			/>
			{isOpen && (
				<div className={style.options}>
					{options.length ? (
						options.map((option) => {
							return (
								<Fragment key={option.value}>
									<p
										data-selected={option.value === submenu.id}
										role="button"
										onClick={(e) => {
											if (option.options?.length) {
												e.stopPropagation();
												setSubmenu({ id: option.value, visibility: true });
											} else {
												onSelect(option.value);
												setIsOpen(false);
											}
										}}
										key={option.value}
										className={style.option}
									>
										<span>{option.label}</span>
										{Boolean(option.options?.length) && (
											<img src={ExpandIcon} alt="expand" />
										)}
									</p>
									{submenu.id === option.value && submenu.visibility && (
										<div
											style={{ transform: 'translateX(100%)', marginTop: -45 }}
											className={style.options}
										>
											{option.options?.map((el) => {
												return (
													<p
														onClick={() => {
															onSelect(option.value + ':' + el.value);
															setIsOpen(false);
															setSubmenu({ visibility: false, id: '' });
														}}
														className={style.option}
														role="button"
														key={el.value}
													>
														{el.label}
													</p>
												);
											})}
										</div>
									)}
								</Fragment>
							);
						})
					) : (
						<p style={{ height: 50 }}></p>
					)}
				</div>
			)}
		</div>
	);
}
